import getV10APIs from './v1.0';
import getV11APIs from './v1.1';
import { mergeVersionsByTitle } from '../../../util/HelperFunctions';

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);
  const v11APIs = getV11APIs(userInfo);

  const children = [
    mergeVersionsByTitle('주문 리스트 조회', v10APIs),
    mergeVersionsByTitle('주문 상세 조회', v10APIs),
    mergeVersionsByTitle('배송정보 업데이트', v10APIs),
    mergeVersionsByTitle('보류', v10APIs),
    mergeVersionsByTitle('주문 삭제', v10APIs),
    mergeVersionsByTitle('주문 상세리스트 조회', v10APIs),
    mergeVersionsByTitle('주문 등록', v10APIs),
    mergeVersionsByTitle('주문 분할', v10APIs),
    mergeVersionsByTitle('주문 수정', v11APIs),
    mergeVersionsByTitle('주문 합포장', v10APIs),
    mergeVersionsByTitle('출고 지시', v10APIs),
    mergeVersionsByTitle('출고 완료', v10APIs),
    mergeVersionsByTitle('주문상태변경', v10APIs),
    mergeVersionsByTitle('규칙 사은품 분배', v10APIs),
    mergeVersionsByTitle('매칭규칙 리스트 조회', v10APIs),
    mergeVersionsByTitle('매칭규칙 등록', v10APIs),
    mergeVersionsByTitle('상태별 주문수량 조회', v10APIs),
    mergeVersionsByTitle('중복의심 해제', v10APIs),
    mergeVersionsByTitle('[해외] 패키지 생성', v10APIs),
    mergeVersionsByTitle('[해외] 패키지 삭제/분리', v10APIs),
    mergeVersionsByTitle('[해외] 패키지 합치기', v10APIs),
    mergeVersionsByTitle('[해외] 배송정보 업데이트', v10APIs),
    mergeVersionsByTitle('출고지시 및 배송정보 업데이트', v10APIs),
  ].filter(Boolean);

  return { title: '주문', children };
};

export default data;
